export default {
    aluguel: [
        {
            id: "residencial",
            titulo: "Residencial",
        },
        {
            id: "comercial",
            titulo: "Comercial",
        },
    ],
    venda: [
        {
            id: "lancamentos",
            titulo: "Imóveis Novos e Lançamentos",
        },
        {
            id: "prontos",
            titulo: "Imóveis Prontos",
        },
    ],
};